import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '@/features/authentication/common/store/authSlice';
import selectedEntityReducer from './selectedEntitySlice';

/**
 * niraxobid.md section 23.7 also registers a `users` slice from
 * features/user-management. That feature is not part of this build; add it here
 * when it lands.
 */
export const rootReducer = combineReducers({
  auth: authReducer,
  /* The legal entity every request is scoped to -- see selectedEntitySlice. */
  selectedEntity: selectedEntityReducer,
});
